module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-45.bd3a2ef4.svg";